
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { isToday, formatDistanceToNow } from 'date-fns';
const Datehistory = ({ date }: any) => {
    const [dt, setDt] = useState()
    const currentDate = new Date()

    const [formattedDate, setFormattedDate] = useState('');
    const [formatedTime, setFormattedTime] = useState('')
    useEffect(() => {
        if (date) {
            if (isToday(new Date(date))) {
                const timeAgo = formatDistanceToNow(new Date(date));

                setFormattedDate(`Today`);
                setFormattedTime(` ${timeAgo} ago`)
            } else {
                const timeAgo = formatDistanceToNow(new Date(date));

                setFormattedDate(`${dayjs(date).format('DD MMMM')} `);
                setFormattedTime(` ${timeAgo} ago`)
            }
        }
    }, [date]);


    return (
        <div className='w-full'>
            <div className='text-sm font-normal text-black'>{formattedDate}</div>
            <div className='text-text_green_1 text-sm font-normal'>{formatedTime}</div>
        </div>
    )
}

export default Datehistory
